import { Grid, Stack, useTheme } from "@mui/material"
import React from "react"
import AppButton from "components/StyledComponents/AppButton"
import { AddOutlined } from "@mui/icons-material"
import RedCloseIcon from "assets/icons/RedCloseIcon.svg"
import AppTextField from "components/StyledComponents/AppTextField"

const HoursOfOperation = ({ data, formik, type }) => {
  const theme = useTheme()
  const handleTimeChange = (e, field, formik) => {
    const value = e?.target ? e.target.value : e
    formik.setFieldValue(field, value)
  }

  const handleDeleteSignatureDishes = (indexToRemove) => {
    const updatedDishes = formik.values?.[type]?.filter((_, i) => i !== indexToRemove)
    formik.setFieldValue(type, updatedDishes)
  }
  const getComponentType = (label) => {
    switch (label) {
      case "text":
        return "textField"
      case "image":
      case "images":
        return "imageUpload"
      case "file":
        return "uploadPdf"
      case "multiple_image":
        return "restaurantImageUpload"
      case "time":
        return "timeField"
      default:
        return "textField"
    }
  }

  return (
    <Grid item xs={12}>
      {Array.isArray(formik?.values?.[type]) &&
        formik?.values?.[type]?.length > 0 &&
        formik?.values?.[type]?.map((dish, id) => (
          <Stack key={`${type}-${id}`} direction="row" justifyContent="start">
            <Grid
              container
              spacing={2}
              width="95%"
              mt={3}
              mb={3}
              mx="auto"
              sx={{
                border: `2px solid ${theme.palette.secondary.default}`,
                borderRadius: "8px",
                pb: 3,
                pr: 2
              }}>
              {data?.[0]?.fields?.map((field, index) => {
                const fieldKey = field?.key
                const componentType = getComponentType(field?.type)
                const fieldName = field?.label
                const fieldPath = `${type}.${id}.${fieldKey}`

                const fieldValue = formik?.values?.[type]?.[id]?.[fieldKey]
                const fieldError = formik?.errors?.[type]?.[id]?.[fieldKey]
                const fieldTouched = formik?.touched?.[type]?.[id]?.[fieldKey]
                switch (componentType) {
                  case "textField":
                    return (
                      <Grid item xs={6}>
                        <AppTextField
                          id={fieldPath}
                          name={fieldPath}
                          type="text"
                          fullWidth
                          isRequired={fieldKey === "name"}
                          label={fieldName}
                          isUpperCase
                          placeholder={`Enter ${fieldName}`}
                          value={fieldValue || ""}
                          onBlur={formik?.handleBlur}
                          onChange={formik?.handleChange}
                          error={Boolean(fieldTouched && fieldError)}
                          touched={fieldTouched}
                          helperText={fieldTouched && fieldError}
                        />
                      </Grid>
                    )

                  case "numberField":
                    return (
                      <Grid item xs={4}>
                        <AppTextField
                          id={fieldPath}
                          name={fieldPath}
                          type="number"
                          fullWidth
                          label={fieldName}
                          isUpperCase
                          placeholder={`Enter ${fieldName}`}
                          value={fieldValue || ""}
                          onChange={formik?.handleChange}
                          onBlur={formik?.handleBlur}
                          error={Boolean(fieldTouched && fieldError)}
                          touched={fieldTouched}
                          helperText={fieldTouched && fieldError}
                        />
                      </Grid>
                    )

                  case "timeField":
                    return (
                      <Grid item xs={6} key={index}>
                        <AppTextField
                          id={fieldPath}
                          type="time"
                          fullWidth
                          label={fieldName}
                          isUpperCase
                          value={fieldValue}
                          onChange={(e) => handleTimeChange(e, fieldPath, formik)}
                          error={Boolean(fieldTouched && fieldError)}
                          helperText={fieldTouched && fieldError}
                        />
                      </Grid>
                    )

                  default:
                    return null
                }
              })}
            </Grid>
            <Stack width="5%">
              {id !== 0 && (
                <img
                  className="flex-shrink-0"
                  role="button"
                  src={RedCloseIcon}
                  onClick={() => handleDeleteSignatureDishes(id)}
                  alt="Delete"
                  style={{ width: 30, marginTop: "20px", marginLeft: "10px" }}
                />
              )}
            </Stack>
          </Stack>
        ))}
      <Grid item xs={12} mt={3}>
        <AppButton
          fullWidth
          onClick={() => {
            const currentDishes = formik?.values?.[type] || []
            const newDish = {}
            data?.[0]?.fields?.forEach((field) => {
              newDish[field.key] = ["uniqueFact", "ingredients"].includes(field.type) ? [] : ""
            })
            formik.setFieldValue(type, [...currentDishes, structuredClone(newDish)])
          }}
          startIcon={<AddOutlined />}>
          Add hours of operation
        </AppButton>
      </Grid>
    </Grid>
  )
}

export default HoursOfOperation
